import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import { intComma } from "humanize-plus";
import React from "react";
import { Link } from "react-router-dom";
import * as uuid from "uuid";
import {
    LoadingTableElement,
    NullTableElement,
} from "../../components/table/nullTable";
import {
    HeadCell,
    SortableTable,
    newDisplayCond,
} from "../../components/table/sortableTable";
import * as usageTripService from "../../services/usage_based_trips/select";
import { commonState, store } from "../../store";
import { colors } from "../../theme";
import { State } from "./store";
interface LinkProps {
    driverId: number;
    driverCode: string;
    driverName: string;
}

type Row = {
    driver_name?: string | JSX.Element;
    driver_code?: string;
    usage_count?: number | JSX.Element;
    payment_amt?: number | JSX.Element;
    row_id: string;
    link_driver_usage?: JSX.Element;
};

const LinkToNext: React.FC<LinkProps> = (props: LinkProps) => {
    const onClick = async () => {
        await usageTripService.select_usage_trips_by_driver(props.driverId);
        await usageTripService.selectUsageTrip();
    };
    return (
        <MenuItem
            to="/driver_usage"
            component={Link}
            sx={{ color: colors.blue.main }}
            onClick={onClick}
        >
            利用実績参照
        </MenuItem>
    );
};

interface Props {
    state: State;
    common: commonState;
}

export const BillingSummaryByDriverContainer: React.FC<Props> = (
    props: Props
) => {
    return (
        <Box>
            <BillingSummaryByDriverTable {...props} />
        </Box>
    );
};

export const BillingSummaryByDriverTable: React.FC<Props> = (props: Props) => {
    let _data: Row[] = [];
    let tableElement = <LoadingTableElement />;
    let footerElement: any = null;

    if (
        props.state.paymentByDriverSummary &&
        props.state.paymentByDriverSummary.payments
    ) {
        console.debug(
            "BillingSummaryByDriverTable:",
            props.state.paymentByDriverSummary.payments
        );

        _data = props.state.paymentByDriverSummary.payments.map(
            (rec): Row => {
                return {
                    driver_name: rec.driverName,
                    driver_code: rec.driverCode,
                    usage_count: rec.nChargeableTrips,
                    payment_amt: rec.price,
                    row_id: uuid.v4(),
                    link_driver_usage: (
                        <LinkToNext
                            driverId={rec.driverId!}
                            driverCode={rec.driverCode!}
                            driverName={rec.driverName!}
                        />
                    ),
                };
            }
        );

        footerElement = {
            driver_name: (
                <Box sx={{ p: 2, float: "right", color: colors.black.main }}>
                    <Typography variant="h3">合計</Typography>
                </Box>
            ),
            usage_count: (
                <Box sx={{ p: 2, color: colors.black.main }}>
                    <Typography variant="h3">
                        {intComma(props.state.paymentByDriverSummary.sumTrips!)}
                    </Typography>
                </Box>
            ),
            payment_amt: (
                <Box sx={{ p: 2, color: colors.black.main }}>
                    <Typography variant="h3">
                        {intComma(props.state.paymentByDriverSummary.sumPrice!)}
                        {"円"}
                    </Typography>
                </Box>
            ),
            row_id: uuid.v4(),
        };

        if (props.state.paymentByDriverSummary.payments.length == 0) {
            tableElement = <NullTableElement />;
        } else {
            tableElement = (
                <SortableTable
                    tableHeaders={headCells}
                    tableData={_data}
                    tableProps={props}
                    displayCond={newDisplayCond("driver_name", "asc", 0, 20)}
                    rowIdField={"row_id"}
                    onRowClickMethod={() => {}}
                    slimRows={true}
                    footer={footerElement}
                />
            );
        }
    }

    let sum: JSX.Element = <></>;
    let officeName = "";
    const officeIds = store.getState().common.officeIds;
    const officeNames = store.getState().common.officeNames;
    for (let i = 0; i < officeIds.length; ++i) {
        if (officeIds[i] === props.common.selectedOfficeId) {
            officeName = officeNames[i];
        }
    }

    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "end",
                    flexDirection: "row",
                }}
            >
                <Box sx={{ p: 2 }}>
                    <Typography variant="h3">営業所 </Typography>
                </Box>
                <Box sx={{ p: 2 }}>{officeName}</Box>

                <Box sx={{ p: 2 }}>{props.state.selectedMonth}</Box>
            </Box>

            <Box>
                {tableElement}
                {sum}
            </Box>
        </Box>
    );
};

const headCells: HeadCell[] = [
    {
        label: "乗務員",
        id: "driver_name",
        numeric: false,
        grow: 3,
    },
    {
        label: "利用回数",
        id: "usage_count",
        numeric: true,
        headerAlignRight: true,
        grow: 2,
        format: (r) => {
            if (typeof r == typeof 3) {
                return intComma(r ? r : 0);
            }
            return r;
        },
    },
    {
        label: "料金",
        id: "payment_amt",
        numeric: true,
        headerAlignRight: true,
        grow: 2,
        format: (r) => {
            if (typeof r == typeof 3) {
                return `${intComma(r ? r : 0)}円`;
            }
            return r;
        },
    },
    {
        label: "",
        id: "link_driver_usage",
        numeric: false,
        grow: 3,
    },
];
